import type { SelectOption } from '@/modules/ui';

// Height is collected as feet + inches and stored as total inches
// (Sparta: `height = feet * 12 + inches`). Ranges mirror stylos's
// CreateProfileForm: feet 3–8, inches 0–11.
export const FEET_OPTIONS: SelectOption[] = Array.from({ length: 6 }, (_, i) => {
  const ft = i + 3;
  return { value: String(ft), label: String(ft) };
});

export const INCHES_OPTIONS: SelectOption[] = Array.from({ length: 12 }, (_, i) => ({
  value: String(i),
  label: String(i),
}));

// Weight bounds (lbs) — the accepted range for the create-profile weight input.
export const MIN_WEIGHT_LBS = 50;
export const MAX_WEIGHT_LBS = 1000;

// Gender enum sent to the backend (single-char), per Sparta's CustomerProfile.
export const GENDER_OPTIONS: SelectOption[] = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'O', label: 'Other' },
];

// Ethnicity slugs sent to the backend, mirroring stylos/Sparta's option set.
export const ETHNICITY_OPTIONS: SelectOption[] = [
  { value: 'american-indian-or-alaska-native', label: 'American Indian or Alaska Native' },
  { value: 'asian', label: 'Asian American' },
  { value: 'black', label: 'Black or African American' },
  { value: 'hispanic', label: 'Hispanic or Latino' },
  { value: 'pacific-islander', label: 'Native Hawaiian or Other Pacific Islander' },
  { value: 'white', label: 'White or Caucasian' },
  { value: 'other', label: 'Other' },
  { value: 'prefer-not-to-state', label: 'Prefer not to state' },
];
